module.exports = __webpack_public_path__ + "static/img/danfang-interior.4d5d897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spirit-farm/buildings/danfang-interior.jpg
// module id = Ph6X
// module chunks = 4